<template>
  <div>
    <div class="isTxt" v-if="isTxt">
      {{ !isNullOrUndefOrEmpty(innerValue) ? innerValue : '-' }}
    </div>
    <RxkSelect
      style="width: 100%"
      v-model:model-value="innerValue"
      :clearable="false"
      :placeholder="renderConfig.placeholder"
      :disabled="renderConfig.disabled"
      :list="quickList"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { RxkSelect } from '@/components/common'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'
import { quickList } from '@/utils/preObjectManage/utils'
const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
